import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

export const isAssemblyStructure = (entity: Entity) => {
  return entity.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID);
};

export const findMatchingAssembly = (coreApi: CoreApi, underframeId: string, frameId: string) => {
  const assembly = coreApi
    .getMainProductCatalog()
    .productDTOs()
    .find(product => {
      const framePart = product.template.parts?.find(
        part => part.partKey === ProductType.KALLAX_FRAME
      );
      const underframe = product.template.parts?.find(
        part => part.partKey === ProductType.KALLAX_UNDERFRAME
      );

      return framePart?.id === frameId && underframe?.id === underframeId;
    });

  return assembly;
};

export const getAssemblyPartProductRef = (
  coreApi: CoreApi,
  selectedEntity: Entity,
  productTypes: ProductType[]
) => {
  const assemblyPart = coreApi.entities.findDescendantWithOneOfProductTypes(
    selectedEntity,
    productTypes
  );

  if (!assemblyPart) return;

  return coreApi.entities.getProductRef(assemblyPart);
};

export const replaceAndSelectEntity = (
  coreApi: CoreApi,
  entityToReplace: Entity,
  newEntityProductRef: string
) => {
  const replaceResult = coreApi.products.replace(entityToReplace.id, newEntityProductRef);
  if (
    replaceResult?.replacedEntityResult.valid &&
    replaceResult.replacedEntityResult.placedEntity
  ) {
    coreApi.entities.select(replaceResult.replacedEntityResult.placedEntity);
  } else {
    coreApi.history.undo();
    coreApi.history.discardLatestSnapshot();
    coreApi.entities.select(entityToReplace);
  }
};
